<template>
  <div class="videoBox">
    <div class="videoBox-main">
      <Upload type="drag" action="/" :before-upload="handleUpload" class="videoBoxContent" v-if="!videoUrl" :class="{'disabled':isUpload}">
        <div class="uplaod-btn" v-if="!isUpload">
          <Icon type="ios-add" size="52" style="color: #3399ff"></Icon>
          <p>上传视频</p>
        </div>
        <div class="uplaod-btn" v-else>
          <Progress :stroke-width="5" :percent="progress"></Progress>
        </div>
      </Upload>
      <div class="videoBoxContent" v-else>
        <video controls="controls" :src="videoUrl"></video>
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native.stop="previewVideo()"></Icon>
          <Icon type="ios-trash-outline" @click.native.stop="removeVideo()"></Icon>
        </div>
      </div>
      <div class="imgCover">
        <uploadImg v-model="imgArr" txt="上传视频封面" @change="uploadCover" />
      </div>
    </div>
    <p class="tip" v-if="tip">{{tip}}</p>
  </div>
</template>

<script>
import { uploadOssVideoFile } from '@/api/httpList';
import uploadImg from '@/components/commons/uploadNew';
export default {
  props: {
    'vUrl':null,
    'iUrl':null,
    'tip':null,
  },
  components: {
    uploadImg
  },
  data() {
    return {
      isUpload: false,
      progress: 0,
      videoUrl: '',
      imgUrl: '',
      imgArr: '',
    };
  },
  watch: {
    vUrl(newVal) {
      this.videoUrl = newVal;
      this.progress = 0;
    },
    iUrl(newVal) {
      this.imgUrl = newVal;
      if(newVal){
        this.imgArr = [{path:newVal}]
      }else{
        this.imgArr = []
      }
      
    }
  },
  methods: {
    // 删除视频
    removeVideo(){
      this.videoUrl = '';
      this.$emit('upload', {
        videoUrl: this.videoUrl,
        imgUrl: this.imgUrl
      });
    },
    // 预览视频
    previewVideo(){
      window.open(this.videoUrl);
    },
    handleUpload(file) {
      this.progress = 0;
      if (!/\.(mp4)$/.test(file.name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传mp4格式视频');
        return false;
      }
      let formData = new FormData();
      formData.append('file', file);
      this.isUpload = true;
      uploadOssVideoFile(formData, e => {
        //文件上传进度条
        if (e.lengthComputable) {
          this.uploadRate = e.loaded / e.total; //已上传的比例
          if (this.uploadRate < 1) {
            //这里的进度只能表明文件已经上传到后台，但是后台有没有处理完还不知道
            //因此不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
            //等响应回来时，再将进度设为100%
            this.progress = +(this.uploadRate * 100).toFixed(2);
          }
        }
      })
        .then(res => {
          this.videoUrl = res.data.videoUrl;
          if(!this.imgUrl){
            this.imgUrl = res.data.videoCover;
            this.imgArr = [{path:res.data.videoCover}];
          }
          this.progress = 100;
          this.isUpload = false;
          this.$emit('upload', {
            videoUrl: this.videoUrl,
            imgUrl: this.imgUrl
          });
        })
        .catch(e => {
          this.videoUrl = null;
          this.progress = 0;
          this.isUpload = false;
        });
      // this.$emit("upload", file);
      return false;
    },
    uploadCover(imgArr) {
      if(!imgArr || imgArr.length==0){
        this.imgUrl = "";
      }else{
        this.imgUrl = imgArr[0].path;
      }
      console.log(this.imgArr)
      this.$emit('upload', {
        videoUrl: this.videoUrl,
        imgUrl: this.imgUrl
      });
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.videoBox {
  width: 100%;
  .videoBox-main {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .imgCover,
  /deep/ .ivu-upload,
  .videoBoxContent {
    width: 267px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .ivu-upload.disabled {
    pointer-events: none;
    cursor: pointer;
  }
  /deep/ .imgCover {
    margin-left: 20px;
    &>.wrapper {
      width: 267px;
      height: 150px;
    }
    .uploadBoxs {
      margin-top: 0;
      .ivu-icon {
        height: auto;
      }
      .ivu-upload > div {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
    }
    .demo-upload-list {
      width: 100%;
      height: 100%;
      margin: 0;
      img {
        width: 100% !important;
        height: 100% !important;
      }
    }
    .tip {
      display: none;
    }
  }
  .videoBoxContent {
    position: relative;
    &:hover .demo-upload-list-cover {
      display: flex;
    }
    .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      align-items: center;
      justify-content: center;
      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        padding: 10px;
      }
    }
    .uplaod-btn {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    video {
      width: 100%;
      height: 100%;
    }
    .ivu-progress {
      width: 70%;
    }
  }
  
  .tip {
    color: #727c8e;
    font-size: 12px;
  }
}
</style>